<template>
  <div>
    <select-editor-collapsed
      v-model="computedChoices"
      v-if="isCollapsed"
      :question="value"
      :isEditable="isEditable"
      @onToggleCollapse="handleToggleCollapse"
    ></select-editor-collapsed>
    <select-editor-expanded
      v-model="computedChoices"
      v-else
      :question="value"
      :isEditable="isEditable"
      @onToggleCollapse="handleToggleCollapse"
    ></select-editor-expanded>
  </div>
</template>

<script>
import SelectEditorCollapsed from './SelectEditorCollapsed';
import SelectEditorExpanded from './SelectEditorExpanded';

export default {
  name: 'SelectEditor',
  components: {
    SelectEditorCollapsed,
    SelectEditorExpanded,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedChoices: {
      get() {
        return this.value.choices || [];
      },
      set(choices) {
        this.$emit('input', { ...this.value, choices });
      },
    },
  },
  methods: {
    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
  },
};
</script>



// WEBPACK FOOTER //
// SelectEditor.vue?d8dc2f92